import { render, staticRenderFns } from "./FormPerson.vue?vue&type=template&id=8f7d4e44&scoped=true&"
import script from "./FormPerson.vue?vue&type=script&lang=js&"
export * from "./FormPerson.vue?vue&type=script&lang=js&"
import style0 from "./FormPerson.vue?vue&type=style&index=0&id=8f7d4e44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7d4e44",
  null
  
)

export default component.exports